<template>
  <div id="app" class="min-h-screen flex flex-col">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>
